import { arrayOf, number, func } from "prop-types";
import { roundFloat } from "@repo/utils";
import { Grid, Slider } from "@material-ui/core";
import useStyle from "./TimerWithInactivity.style";

export const TimerWithInactivity = ({
  playTime,
  totalTime,
  startTime,
  inactivePeriods,
  onSliderDrag,
  onSliderDragEnd,
}) => {
  const classes = useStyle();
  
  return (
    <Grid item container>
      <Slider
        color="primary"
        value={playTime}
        onChange={onSliderDrag}
        onChangeCommitted={onSliderDragEnd}
        className={classes.slider}
        max={totalTime}
      />
      <div className={classes.inactivityContainer}>
        {
          inactivePeriods.map((inactivePeriod) => (
            <div
              key={inactivePeriod[0]}
              className={classes.inactivityBlock}
              style={{
                left: `${roundFloat((inactivePeriod[0] - startTime) / totalTime * 100)}%`,
                width: `${roundFloat((inactivePeriod[1] - inactivePeriod[0]) / totalTime * 100)}%`,
              }}
            />
          ))
        }
      </div>
    </Grid>
  )
}

TimerWithInactivity.propTypes = {
  playTime: number.isRequired,
  totalTime: number.isRequired,
  startTime: number.isRequired,
  inactivePeriods: arrayOf(arrayOf(number)).isRequired,
  onSliderDrag: func.isRequired,
  onSliderDragEnd: func.isRequired,
}